<template>
	<div class="layout-footer">
		<img alt="Logo" :src="footerImage()" />
		by
		<span class="font-medium ml-2">MSRTC</span>
	</div>
</template>

<script>
	export default {
		name: "AppFooter",
		methods: {
			footerImage() {
				return this.$appState.darkTheme ? 'images/logox.png' : 'images/logox.png';
			}
		},
		computed: {
			darkTheme() {
				return this.$appState.darkTheme;
			}
		}
	}
</script>
<style>
.layout-topbar,.layout-sidebar{
  box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px !important; 
	background: linear-gradient(90deg, rgba(131, 58, 180, 1) 0%, rgba(69, 70, 252, 1) 100%) !important;
}
.layout-topbar .layout-topbar-button{
  color: white;
}
.layout-menu li a{
  color: white;
}
.layout-menu li a:hover{
  color:black;
}

body{
	background-color: #EFF3F8;
}
/* .layout-main-container{
    background-color: black !important;
}
.layout-wrapper{
    background-color: black !important;
} */
</style>
